/**
 * Muscle Grenade — countdown Noche Grenade / Halloween 2026
 * Hasta el 31 de octubre, luego las ofertas siguen hasta el lunes 2 de noviembre (hora de Chile, -03).
 */
(function () {
  'use strict';

  var NIGHT = new Date('2026-10-31T00:00:00-03:00').getTime();
  var OFFER_END = new Date('2026-11-02T23:59:59-03:00').getTime();

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick(root) {
    var now = Date.now();
    var target = NIGHT;
    var label = root.querySelector('[data-mg-count-label]');
    var done = root.querySelector('[data-mg-count-done]');
    var grid = root.querySelector('[data-mg-count-grid]');

    if (now < NIGHT) {
      if (label) label.textContent = 'Faltan para Halloween';
    } else if (now < OFFER_END) {
      target = OFFER_END;
      if (label) label.textContent = 'Ofertas hasta el lunes 2';
    } else {
      if (done) done.hidden = false;
      if (grid) grid.hidden = true;
      if (label) label.textContent = 'Campaña cerrada';
      return;
    }

    var diff = Math.max(0, target - now);
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    ['d', 'h', 'm', 's'].forEach(function (key, i) {
      var el = root.querySelector('[data-mg-count="' + key + '"]');
      if (el) el.textContent = pad([d, h, m, s][i]);
    });
  }

  function start() {
    var nodes = document.querySelectorAll('[data-mg-countdown]');
    if (!nodes.length) return;
    nodes.forEach(function (node) {
      tick(node);
      setInterval(function () {
        tick(node);
      }, 1000);
    });
  }

  function retitleNav() {
    var links = document.querySelectorAll('a[href*="mes-de-la-patria"]');
    links.forEach(function (a) {
      if (/patria/i.test(a.textContent || '')) {
        a.textContent = 'Noche Grenade';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
      retitleNav();
    });
  } else {
    start();
    retitleNav();
  }
})();
